/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Contract,
  ContractFactory,
  ContractTransactionResponse,
  Interface,
} from "ethers";
import type { Signer, ContractDeployTransaction, ContractRunner } from "ethers";
import type { NonPayableOverrides } from "../common";
import type {
  CollateralPosition,
  CollateralPositionInterface,
} from "../CollateralPosition";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "landTokenAmount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "stableTokenAmount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "enum TransactionType",
        name: "transactionType",
        type: "uint8",
      },
    ],
    name: "CollateralPositionTransaction",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint8",
        name: "version",
        type: "uint8",
      },
    ],
    name: "Initialized",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "OWNER_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "landTokenAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "stableTokenAmount",
        type: "uint256",
      },
    ],
    name: "adjustCollateralPosition",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "landTokenAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "stableTokenAmount",
        type: "uint256",
      },
    ],
    name: "closeCollateralPosition",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "collateralDebtPositionByAddress",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "owner",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "stableTokenAmount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "landTokenAmount",
            type: "uint256",
          },
        ],
        internalType: "struct ICollateralPosition.CollateralDebtPosition",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "collateralDebtPositionById",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "owner",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "stableTokenAmount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "landTokenAmount",
            type: "uint256",
          },
        ],
        internalType: "struct ICollateralPosition.CollateralDebtPosition",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "owner",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "stableTokenAmount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "landTokenAmount",
            type: "uint256",
          },
        ],
        internalType: "struct ICollateralPosition.CollateralDebtPosition",
        name: "collateralPosition",
        type: "tuple",
      },
    ],
    name: "collateralRatio",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "dollarPerSquareFootOracle",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "exchangeRateConverter",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getStableTokensInCollateralPositions",
    outputs: [
      {
        internalType: "uint256",
        name: "collateralStableTokens",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "shareLandTokenAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "priceOracleAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "exchangeRateConverterAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "stableTokenAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "liquidityProviderTokenAddress",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "liquidationRatioWithTwoDigits",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "liquidationTokenRatioWithTwoDigits",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "liquidationStableRatioWithTwoDigits",
        type: "uint256",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "collateralDebtPositionIds",
        type: "uint256",
      },
    ],
    name: "liquidatePosition",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "liquidationLandRatio",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "liquidationRatio",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "liquidationStableRatio",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "landTokenAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "stableTokenAmount",
        type: "uint256",
      },
    ],
    name: "openCollateralPosition",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "oraclePrice",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "performLiquidation",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "owner",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "stableTokenAmount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "landTokenAmount",
            type: "uint256",
          },
        ],
        internalType: "struct ICollateralPosition.CollateralDebtPosition",
        name: "cdp",
        type: "tuple",
      },
    ],
    name: "purchaseCostToClosePosition",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "shareLandMarketAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "orderBookAddress",
        type: "address",
      },
    ],
    name: "setExternalDependencies",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "liquidationRatioWithTwoDigits",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "liquidationTokenRatioWithTwoDigits",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "liquidationStableRatioWithTwoDigits",
        type: "uint256",
      },
    ],
    name: "setLiquidationRation",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "exchangeRateConverterAddress",
        type: "address",
      },
    ],
    name: "updateExchangeRateConverter",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type CollateralPositionConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: CollateralPositionConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class CollateralPosition__factory extends ContractFactory {
  constructor(...args: CollateralPositionConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override getDeployTransaction(
    overrides?: NonPayableOverrides & { from?: string }
  ): Promise<ContractDeployTransaction> {
    return super.getDeployTransaction(overrides || {});
  }
  override deploy(overrides?: NonPayableOverrides & { from?: string }) {
    return super.deploy(overrides || {}) as Promise<
      CollateralPosition & {
        deploymentTransaction(): ContractTransactionResponse;
      }
    >;
  }
  override connect(runner: ContractRunner | null): CollateralPosition__factory {
    return super.connect(runner) as CollateralPosition__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): CollateralPositionInterface {
    return new Interface(_abi) as CollateralPositionInterface;
  }
  static connect(
    address: string,
    runner?: ContractRunner | null
  ): CollateralPosition {
    return new Contract(address, _abi, runner) as unknown as CollateralPosition;
  }
}
